// extracted by mini-css-extract-plugin
module.exports = {"TalentConcierge":"q8Lm6mNS","bottom":"_2E63-_8-","adminDataInfoWrapper":"-jWLIO7j","dataInfoWrapper":"_2N3DfjVD","adminDataAvatarWrapper":"EDCLnEfU","smallText":"_1wjYHT7B","adminName":"djbcLSMH","adminDataSubtitle":"M5dtquy0"};
    if(module.hot) {
      // 1746735794170
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  